import { gql } from '@apollo/client';

export default gql`
  mutation adjustPointsEnhancement(
    $membershipNumber: String!
    $amountRewardPoints: Float!
    $amountAcceleratorPoints: Float!
    $amountStatusPoints: Float!
    $reasonCode: String!
    $reasonText: String!
    $comments: String!
    $actionBy: String!
    $pnr: String!
    $tcn: String
  ) {
    adjustPointsEnhancement(
      membershipNumber: $membershipNumber
      amountRewardPoints: $amountRewardPoints
      amountAcceleratorPoints: $amountAcceleratorPoints
      amountStatusPoints: $amountStatusPoints
      reasonCode: $reasonCode
      reasonText: $reasonText
      comments: $comments
      actionBy: $actionBy
      pnr: $pnr
      tcn: $tcn
    ) {
      success
    }
  }
`;
